import store from '../../config/configureStore';
import { getActiveErrors } from 'simpl-schema-validation/helpers/errorTree';

export const countPropertiesErrors = (incIncidentPropertyId) => {
  let currentIncidentId = parseInt(store.store.getState().incident.ptsIncidentId);
  let validationErrors = store.store.getState().incident.validationErrors;

  const errorObj = validationErrors.find((error) => error.ptsIncidentId === currentIncidentId);

  if (!errorObj?.errors?.propertiesErrors) {
    return 0;
  }
  let errorCount = 0;

  for (let error of getActiveErrors(errorObj.errors.propertiesErrors)) {
    if (error.incIncidentPropertyId === incIncidentPropertyId) {
      errorCount++;
    }
  }
  return errorCount;
};
